import React, { useState, useEffect } from 'react';
import MenuTab from './MenuTab';
import logo from '../assets/logo_no_bg.png';
import { MdLightMode } from "react-icons/md";
import { BsFillMoonFill } from "react-icons/bs";
import TranslateButton from './TranslateButton';

const Header = () => {
  const [theme, setTheme] = useState('light');
  // const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const storedTheme = localStorage.getItem('theme');
    if (storedTheme) {
      setTheme(storedTheme);
      document.documentElement.classList.toggle('dark', storedTheme === 'dark');
    }
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
    document.documentElement.classList.toggle('dark', newTheme === 'dark');
  };

  return (
    <header className={`
      sticky top-0 left-0 right-0 z-50 
      transition-all duration-300 ease-in-out 
      bg-white/90 dark:bg-gray-900/90 
      backdrop-blur-md 
      shadow-md dark:shadow-xl max-md:py-3 md:py-2
    `}>
      <div className="container mx-auto px-4 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <img 
            src={logo} 
            alt="Abbas-Logo" 
            className={`
              transition-all duration-300 w-12 hover:scale-105 drop-shadow-md
            `} 
          />
          <h1 className="
            font-serif text-xl sm:text-2xl 
            text-gold-dark
            font-bold 
            tracking-wider 
            hidden sm:block
          ">
            Abbas Restaurant
          </h1>
        </div>
        
        <div className="flex items-center gap-4 sm:gap-6">
          <TranslateButton />
          
          <div 
            onClick={toggleTheme} 
            className="
              p-2 rounded-full 
              bg-gold-dark/10 dark:bg-gold-light/20 
              hover:bg-gold-dark/20 dark:hover:bg-gold-light/30 
              transition-colors duration-300 
              cursor-pointer 
              flex items-center justify-center
            "
          >
            {theme === 'dark' ? (
              <MdLightMode className="text-2xl sm:text-3xl text-gold-dark hover:scale-110 transition-transform" />
            ) : (
              <BsFillMoonFill className="text-xl sm:text-2xl text-gold-dark hover:scale-110 transition-transform" />
            )}
          </div>
          
          <MenuTab />
        </div>
      </div>
    </header>
  );
};

export default Header;